'use client';

import React, {FC} from 'react';

import {BrandIcons} from '../index.d';

import styles from './styles.module.scss';

const DEFAULT_ICONS: BrandIcons[] = [
  {
    image: '/static/img/homepage/webp/WSJ.svg',
    alt: 'WSJ',
    className: 'as-featured__brands_item_wsj-icon',
    width: 35,
    height: 52,
  },
  {
    image: '/static/img/homepage/forbes.png',
    webp: '/static/img/homepage/webp/forbes.webp',
    alt: 'Forbes',
    width: 120,
    height: 52,
  },
  {
    image: '/static/img/homepage/business-insider.png',
    webp: '/static/img/homepage/webp/business-insider.webp',
    alt: 'Business insider',
    width: 120,
    height: 52,
  },
  {
    image: '/static/img/homepage/cnbc.png',
    webp: '/static/img/homepage/webp/cnbc.webp',
    alt: 'CNBC',
    width: 120,
    height: 52,
  },
];

interface AsFeaturedProps {
  brandIcons?: BrandIcons[];
}

const AsFeatured: FC<AsFeaturedProps> = ({brandIcons = DEFAULT_ICONS}) => {
  if (!brandIcons.length) {
    return null;
  }

  return (
    <section className={styles['section-asFeatured']}>
      <div className="default-container">
        <div className={styles['as-featured']}>
          <div className={styles['as-featured__brands']}>
            {brandIcons.map((icon, index) => {
              if (!icon.image && !icon.webp) {
                return null;
              }

              const sourceArray = icon.image.split('.');
              const extension = sourceArray[sourceArray.length - 1];
              const key = `image_${index}`;

              return (
                <div key={key} className={styles['as-featured__brands_item']}>
                  <picture
                    className={
                      icon.className ? styles[icon.className] : undefined
                    }>
                    {icon.image && (
                      <source srcSet={icon.image} type={`image/${extension}`} />
                    )}
                    <img
                      src={icon.webp || icon.image}
                      alt={icon.alt}
                      className="img-responsive"
                      width={icon.width}
                      height={icon.height}
                    />
                  </picture>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AsFeatured;
